import EA from '../helpers/init';

export default EA.Methods.generalDropdownLogic = ($this) => {
    const dropdownOpener = $this.querySelector('.general-dropdown-selected-option');
    const dropdownOpenerText = $this.querySelector('.general-dropdown-selected-option-text');
    const dropdownList = $this.querySelector('.general-dropdown-list-wrapper');
    const dropdownOptions = $this.querySelectorAll('.general-dropdown-option');

    dropdownOpener.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdownList.classList.toggle('active');
    });

    document.addEventListener('click', () => {
        dropdownList.classList.remove('active');
    });

    dropdownOptions.forEach(option => {
        option.addEventListener('click', (e) =>{
            e.stopPropagation();
            dropdownOpenerText.innerText = option.dataset.label;
            dropdownList.classList.remove('active');
        });
    });
};
